import { svgMarkerIcons, mapStyles } from './../utils/wappo.gmap.const'

let bounds = new google.maps.LatLngBounds();
let markers = new Array();
let locations = new Array();

function addMarkers(map)
{
	for (let i = 0; i < locations.length; i++)
	{
		const refactoredPosition = { lat: locations[i].position.latitude, lng: locations[i].position.longitude }
		let iconIndex = 0;

		// CUSTOM ICONS
		switch (locations[i].typology)
		{
			case "Offices":
			case "Mono-tenant Offices":
			case "Multi-tenant Offices":
				iconIndex = 1;
				break;
			case "Retail":
			case "Retail Park":
			case "High street retail":
				iconIndex = 2;
				break;
			case "Hospitality":
				iconIndex = 3;
				break;
			default:
				iconIndex = 0;
				break;
		}

		// MARKER
		let marker = new google.maps.Marker({
			id: locations[i].id,
			position: refactoredPosition,
			//map,
			title: locations[i].typology + " | " + locations[i].destination,
			icon: svgMarkerIcons[iconIndex]
		});

		marker.addListener('click', function ()
		{
			window.location.href = locations[i].url;
		});

		markers.push(marker);
		bounds.extend(refactoredPosition);

		// MARKER ANIMATION
		setTimeout(function ()
		{
			marker.setAnimation(google.maps.Animation.DROP);
			marker.setMap(map);
		}, i * 80);
	}

	// MAP FIT BOUNDS
	map.fitBounds(bounds, 0);

	// MAP CLUSTER ICONS
	////new markerClusterer.MarkerClusterer(
	////   { 
	////      markers: markers, 
	////      map: map,
	////      renderer: 
	////      {
	////         render: ({ count, position }, stats) =>{
	////            // create svg url with fill color
	////            const svgCircle = window.btoa(`
	////               <svg fill="#fff" opacity="1@*${count / stats.clusters.markers.max}*@" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 240 240">
	////                  <circle cx="120" cy="120" opacity=".8" r="70" />    
	////               </svg>`);

	////            return new google.maps.Marker({
	////               label: { text: String(count), color: "#000", fontSize: "15px", fontWeight: "bold" },
	////               icon: {
	////                     url: `data:image/svg+xml;base64,${svgCircle}`,
	////                     scaledSize: new google.maps.Size(50, 50),
	////               },
	////               position,
	////               // adjust zIndex to be above other markers
	////               zIndex: Number(google.maps.Marker.MAX_ZINDEX) + count,
	////            });
	////         }
	////      }
	////   }
	////);
}

function initMap()
{
	const map = new google.maps.Map(
		document.getElementById("map"),
		{
			zoom: 4,
			styles: mapStyles,
			mapTypeControl: false,
			streetViewControl: false,
			fullscreenControl: false,
			center: { lat: 41.9, lng: 12.5 } // Rome
		}
	);

	// When map ready add markers
	google.maps.event.addListenerOnce(map, 'idle', function ()
	{
		setTimeout(function ()
		{
			addMarkers(map);
		}, 500);
	});
}

$(document).ready(function ()
{
	const modelId = $("#map").data("model-id");

	// FETCH LOCATIONS
	$.ajax({
		url: "/gmap/locations/" + modelId,
		type: "GET",
		success: function (result)
		{
			locations = result;

			initMap();
		},
		error: function (jqXHR, textStatus, errorThrown)
		{
			console.log("!AJAX ERROR! " + errorThrown);
		}
	});
});